import type { SolvedSquare } from './solver.model';

/**
 * Solve a square given its side length.
 * Returns all properties and vertices in canonical placement.
 *
 * Canonical placement: same as rectangle with w=h=s.
 * A = (0,0), B = (s,0), C = (s,s), D = (0,s) (counterclockwise)
 */
export function solveSquare(s: number): SolvedSquare {
  if (s <= 0) {
    throw new Error(`Side length must be positive: s=${s}`);
  }

  return {
    vertices: {
      A: [0, 0],
      B: [s, 0],
      C: [s, s],
      D: [0, s],
    },
    s,
    d: s * Math.SQRT2,
    area: s * s,
    perimeter: 4 * s,
  };
}
